webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return firebaseApp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp({
  apiKey: 'AIzaSyAExn1UpSdJanCXpmAyRPb8jWL5fgyHZKo',
  authDomain: 'controle-biodigestor.firebaseapp.com',
  databaseURL: 'https://controle-biodigestor.firebaseio.com',
  projectId: 'controle-biodigestor',
  storageBucket: 'controle-biodigestor.appspot.com',
  messagingSenderId: '200358044541'
});

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(300)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(350),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var files = __webpack_require__(353);
var modules = {};

files.keys().forEach(function (key) {
  if (key === './index.js') return;
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default;
});

/* harmony default export */ __webpack_exports__["default"] = (modules);

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(289)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(334),
  /* scopeId */
  "data-v-3198abf4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


if (window.localStorage.getItem('token')) {
  __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['Authorization'] = window.localStorage.getItem('token');
}

__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL = 'https://mpsolidtec.com.br/mpcontrolebio/public';
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

window.axios = __WEBPACK_IMPORTED_MODULE_0_axios___default.a;

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = domain;
/* harmony export (immutable) */ __webpack_exports__["a"] = count;
/* harmony export (immutable) */ __webpack_exports__["c"] = prettyDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = pluralize;
var urlParser = document.createElement('a');

function domain(url) {
  urlParser.href = url;
  return urlParser.hostname;
}

function count(arr) {
  return arr.length;
}

function prettyDate(date) {
  var a = new Date(date);
  return a.toDateString();
}

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }

  return time + label + 's';
}

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Logout_vue__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Logout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Logout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_404_vue__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_Usuario_vue__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_Usuario_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_views_Usuario_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Manutencao_vue__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Manutencao_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_views_Manutencao_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_Graficos_vue__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_Graficos_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_views_Graficos_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_GraficosMaterial_vue__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_GraficosMaterial_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_views_GraficosMaterial_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_GraficosAcumulados_vue__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_GraficosAcumulados_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_views_GraficosAcumulados_vue__);












var routes = [{
  path: '/login',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default.a
}, {
  path: '/logout',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Logout_vue___default.a
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default.a,
  children: [{
    path: 'dashboard',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_4__components_views_Dashboard_vue___default.a,
    name: 'Principal',
    meta: {
      namePtbr: 'Principal',
      nameDe: 'Main',
      nameEn: 'Home',
      nameEs: 'Principal',
      descriptionPtbr: 'Monitoramento do Biodigestor Ronchi',
      descriptionDe: 'Ronchi Biodigester Überwachung',
      descriptionEn: 'Ronchi Biodigester Monitoring',
      descriptionEs: 'Monitoreo de Biodigestores Ronchi',
      requiresAuth: true
    }
  }, {
    path: 'usuario',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_5__components_views_Usuario_vue___default.a,
    name: 'Usuário',
    meta: {
      namePtbr: 'Usuário',
      nameDe: 'Benutzer',
      nameEn: 'User',
      nameEs: 'Usuario',
      descriptionPtbr: 'Edição dos dados de Usuário',
      descriptionDe: 'Benutzerdaten bearbeiten',
      descriptionEn: 'Editing User Data',
      descriptionEs: 'Edición de datos de usuario',
      requiresAuth: true
    }
  }, {
    path: 'manutencao',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_6__components_views_Manutencao_vue___default.a,
    name: 'Manutenção',
    meta: {
      namePtbr: 'Manutenção',
      nameDe: 'Wartung',
      nameEn: 'Maintenance',
      nameEs: 'Mantenimiento',
      descriptionPtbr: 'Monitoramento de todas variáveis do Biodigestor Ronchi',
      descriptionDe: 'Überwachung aller Variablen von Ronchi Biodigester',
      descriptionEn: 'Monitoring of all Ronchi Biodigester variables',
      descriptionEs: 'Monitoreo de todas las variables de Biodigestores Ronchi',
      requiresAuth: true
    }
  }, {
    path: 'graficos',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_7__components_views_Graficos_vue___default.a,
    name: 'Gráficos',
    meta: {
      namePtbr: 'Gráficos',
      nameDe: 'Diagramme',
      nameEn: 'Charts',
      nameEs: 'Gráficos',
      descriptionPtbr: 'Relatório das variáveis do Biodigestor Ronchi',
      descriptionDe: 'Grafik der Variablen des Biodigestor Ronchi',
      descriptionEn: 'Graph of the variables of the Biodigestor Ronchi',
      descriptionEs: 'Gráfico de las variables del Biodigestor Ronchi.',
      requiresAuth: true
    }
  }, {
    path: 'graficos-material',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_8__components_views_GraficosMaterial_vue___default.a,
    name: 'Gráficos Material',
    meta: {
      namePtbr: 'Gráficos',
      nameDe: 'Diagramme',
      nameEn: 'Charts',
      nameEs: 'Gráficos',
      descriptionPtbr: 'Valores de análise do material do Biodigestor Ronchi',
      descriptionDe: 'Analysewerte des Materials des Biodigestor Ronchi',
      descriptionEn: 'Values ​​of analysis of the material of the Biodigestor Ronchi',
      descriptionEs: 'Valores de análisis del material del Biodigestor Ronchi.',
      requiresAuth: true
    }
  }, {
    path: 'graficos-acumulados',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_9__components_views_GraficosAcumulados_vue___default.a,
    name: 'Gráficos Acumulados',
    meta: {
      namePtbr: 'Gráficos',
      nameDe: 'Diagramme',
      nameEn: 'Charts',
      nameEs: 'Gráficos',
      descriptionPtbr: 'Crescimento diário dos valores acumulados.',
      descriptionDe: 'Tägliches Wachstum der akkumulierten Werte',
      descriptionEn: 'Daily growth of accumulated values',
      descriptionEs: 'Crecimiento diario de los valores acumulados.',
      requiresAuth: true
    }
  }]
}, {
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_3__components_404_vue___default.a
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules__ = __webpack_require__(28);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  modules: __WEBPACK_IMPORTED_MODULE_5__modules__["default"]
}));

/***/ }),
/* 158 */,
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */,
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(341),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filters__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_App_vue__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuefire__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_filters__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_sweetalert2__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_min_css__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2_dist_sweetalert2_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_country_flag__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_analytics__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__axios__ = __webpack_require__(154);















__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vuefire__["a" /* rtdbPlugin */]);



__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue2_filters___default.a);



__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_sweetalert2__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('country-flag', __WEBPACK_IMPORTED_MODULE_12_vue_country_flag__["a" /* default */]);



__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('count', __WEBPACK_IMPORTED_MODULE_6__filters__["a" /* count */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('domain', __WEBPACK_IMPORTED_MODULE_6__filters__["b" /* domain */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('prettyDate', __WEBPACK_IMPORTED_MODULE_6__filters__["c" /* prettyDate */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('pluralize', __WEBPACK_IMPORTED_MODULE_6__filters__["d" /* pluralize */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_4__routes__["a" /* default */],
  mode: 'history',
  linkExactActiveClass: 'active',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13_vue_analytics___default.a, {
  id: 'UA-170841531-1',
  router: router
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  }) && (!router.app.$store.state.token || router.app.$store.state.token === 'null')) {
    window.console.log('Not authenticated');
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */], router);

if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null';
  var localUser = JSON.parse(localUserString);

  if (localUser && __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.user !== localUser) {
    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('SET_USER', localUser);
    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('SET_TOKEN', window.localStorage.getItem('token'));
  }
}



new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#root',
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_7__components_App_vue___default.a);
  }
});

window.bugsnagClient = window.bugsnag('02fe1c2caaf5874c50b6ee19534f5932');
window.bugsnagClient.use(window.bugsnag__vue(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]));

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var state = {
  dia: {},
  historico: {},
  acumulado: {},
  titulo: '',
  cnpj: ''
};

var mutations = {
  fillDataRelatorioDia: function fillDataRelatorioDia(state, res) {
    state.dia = res.data;
  },
  fillDataRelatorioHistorico: function fillDataRelatorioHistorico(state, res) {
    state.historico = res.data;
  },
  fillDataRelatorioAcumulado: function fillDataRelatorioAcumulado(state, res) {
    state.acumulado = res.data.grafico;
    state.titulo = res.data.titulo;
  },
  fillDataRelatorioHistoricoDias: function fillDataRelatorioHistoricoDias(state, res) {
    state.historico = res.data.grafico;
    state.titulo = res.data.titulo;
  }
};

var actions = {
  createRelatorioHistorico: function createRelatorioHistorico(context, data) {
    var qs = __webpack_require__(18);
    data = qs.stringify(data);
    return window.axios.post('/api/v1/sd202019/relatorios', data).then(function (res) {
      context.commit('fillDataRelatorioHistorico', res);
      return res;
    });
  },
  createRelatorioGeracaoSeteDias: function createRelatorioGeracaoSeteDias(context, data) {
    var qs = __webpack_require__(18);
    data = qs.stringify(data);
    return window.axios.post('/api/v1/sd202019/relatorios/setedias', data).then(function (res) {
      context.commit('fillDataRelatorioHistoricoDias', res);
      console.log(res);
      return res;
    });
  },
  createRelatorioAcumuladoDias: function createRelatorioAcumuladoDias(context, data) {
    var qs = __webpack_require__(18);
    data = qs.stringify(data);
    return window.axios.post('/api/v1/sd202019/relatorios/dias', data).then(function (res) {
      context.commit('fillDataRelatorioAcumulado', res);
      return res;
    });
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  TOGGLE_LOADING: function TOGGLE_LOADING(state) {
    state.callingAPI = !state.callingAPI;
  },
  TOGGLE_SEARCHING: function TOGGLE_SEARCHING(state) {
    state.searching = state.searching === '' ? 'loading' : '';
  },
  SET_USER: function SET_USER(state, user) {
    state.user = user;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_LANG: function SET_LANG(state, lang) {
    state.flag = lang;
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  callingAPI: false,
  searching: '',
  serverURI: 'http://10.110.1.136:8080',
  user: null,
  token: null,
  flag: 'br'
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFound',
  methods: {
    track: function track() {
      this.$ga.page('/404');
    }
  },
  computed: {
    flag: function flag() {
      return this.$store.state.flag;
    }
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  data: function data() {
    return {
      section: 'Head'
    };
  },

  methods: {
    logout: function logout() {
      this.$store.commit('SET_USER', null);
      this.$store.commit('SET_TOKEN', null);

      if (window.localStorage) {
        window.localStorage.setItem('user', null);
        window.localStorage.setItem('token', null);
      }

      this.$router.push('/login');
    }
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_Sidebar__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__layout_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_DashHeader__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_DashHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__layout_DashHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_DashFooter__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_DashFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__layout_DashFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hideseek__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hideseek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hideseek__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dash',
  components: {
    DashHeader: __WEBPACK_IMPORTED_MODULE_4__layout_DashHeader___default.a,
    DashFooter: __WEBPACK_IMPORTED_MODULE_5__layout_DashFooter___default.a,
    Sidebar: __WEBPACK_IMPORTED_MODULE_3__layout_Sidebar___default.a
  },
  data: function data() {
    return {
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].fixedLayout,
        hide_logo: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].hideLogoOnMobile
      },
      error: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userInfo']), {
    flag: function flag() {
      return this.$store.state.flag;
    },
    user: function user() {
      return {
        displayName: this.$store.state.user.displayName,
        avatar: '../static/img/users.png',
        roles: [this.$store.state.user.email]
      };
    },
    demo: function demo() {
      return {
        displayName: this.$store.state.user.displayName,
        avatar: '../static/img/users.png',
        email: this.$store.state.user.email
      };
    }
  }),
  methods: {
    changeloading: function changeloading() {
      this.$store.commit('TOGGLE_SEARCHING');
    }
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__ = __webpack_require__(7);




var db = __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__["a" /* firebaseApp */].database();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  data: function data(router) {
    return {
      section: 'Login',
      loading: '',
      email: '',
      password: '',
      response: ''
    };
  },

  methods: {
    switchLang: function switchLang(lang) {
      this.$store.commit('SET_LANG', lang);
    },

    signIn: function signIn() {
      var _this = this;

      this.toggleLoading();
      __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__["a" /* firebaseApp */].auth().signInWithEmailAndPassword(this.email, this.password).then(function (resposta) {
        _this.toggleLoading();

        _this.$store.commit('SET_TOKEN', resposta.user.refreshToken);

        _this.$store.commit('SET_USER', __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__["a" /* firebaseApp */].auth().currentUser);
        var uid = __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__["a" /* firebaseApp */].auth().currentUser.uid;
        var Users = db.ref('Users/' + uid);
        Users.on('value', function (snapshot) {}, function (errorObject) {
          console.log('The read failed: ' + errorObject.code);
        });

        _this.$router.push('/');
      }, function (err) {
        _this.$store.commit('TOGGLE_LOADING');
        _this.toggleLoading();
        alert(err.message);
      });
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'loading' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
    }
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Logout',
  data: function data(router) {
    return {
      section: 'Logout',
      loading: '',
      password: '',
      response: '',
      email: ''
    };
  },
  mounted: function mounted() {
    this.signOut();
  },

  methods: {
    signOut: function signOut() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signOut().then(function (resposta) {
        _this.$store.commit('SET_TOKEN', null);
        _this.$store.commit('SET_USER', null);
        window.localStorage.setItem('token', null);
        window.localStorage.setItem('user', null);
        _this.$router.push('/login');
      });
    }
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Chart',
  props: {
    'chart-config': {
      type: Object,
      validator: function validator(value) {
        var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(value);
        if (!keys.includes('type')) {
          console.error('[Chart.js] Object must has type (key)');
          return false;
        }
        if (!keys.includes('data')) {
          console.error('[Chart.js] Object must has data (key)');
          return false;
        }
        return true;
      }
    }
  },
  mounted: function mounted() {
    var chartCanvas = this.$el.getContext('2d');
    var chartConfig = this.chartConfig;
    new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(chartCanvas, chartConfig);
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashFooter',
  computed: {
    flag: function flag() {
      return this.$store.state.flag;
    }
  },
  data: function data() {
    return {
      year: new Date().getFullYear()
    };
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessagesMenu__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessagesMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MessagesMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotificationsMenu__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotificationsMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__NotificationsMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LanguagesMenu__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LanguagesMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__LanguagesMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TasksMenu__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TasksMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TasksMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserMenu__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__UserMenu__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashHeader',
  components: {
    MessagesMenu: __WEBPACK_IMPORTED_MODULE_2__MessagesMenu___default.a,
    LanguagesMenu: __WEBPACK_IMPORTED_MODULE_4__LanguagesMenu___default.a,
    NotificationsMenu: __WEBPACK_IMPORTED_MODULE_3__NotificationsMenu___default.a,
    TasksMenu: __WEBPACK_IMPORTED_MODULE_5__TasksMenu___default.a,
    UserMenu: __WEBPACK_IMPORTED_MODULE_6__UserMenu___default.a
  },
  props: ['user'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userInfo']), {
    demo: function demo() {
      return {
        displayName: this.$store.state.user.displayName,
        avatar: '../static/img/users.png',
        email: this.$store.state.user.email
      };
    }
  })
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_country_flag__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotificationItem__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotificationItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__NotificationItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_firebaseApp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_filters__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_filters__);









var db = __WEBPACK_IMPORTED_MODULE_4__helpers_firebaseApp__["a" /* firebaseApp */].database();
var sd022020Ref = db.ref('sd022020');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LanguagensMenu',
  components: {
    NotificationItem: __WEBPACK_IMPORTED_MODULE_3__NotificationItem___default.a,
    CountryFlag: __WEBPACK_IMPORTED_MODULE_1_vue_country_flag__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5_vue2_filters___default.a.mixin],
  data: function data() {
    return {
      tab: 'new',
      registros: []
    };
  },

  firebase: {
    registros: sd022020Ref
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['userInfo']), {
    flag: function flag() {
      return this.$store.state.flag;
    },
    newNotifications: function newNotifications() {
      return this.userInfo.notifications.filter(function (n) {
        return !n.readAt;
      });
    },
    oldNotifications: function oldNotifications() {
      return this.userInfo.notifications.filter(function (n) {
        return n.readAt;
      });
    }
  }),
  methods: {
    markAllAsRead: function markAllAsRead() {
      event.stopPropagation();

      this.userInfo.notifications.filter(function (n) {
        return !n.readAt;
      }).forEach(function (notification) {
        notification.readAt = new Date().toUTCString;
      });
    },
    switchLang: function switchLang(lang) {
      this.$store.commit('SET_LANG', lang);
    }
  }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MessageItem',
  props: ['message']
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessageItem__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessageItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MessageItem__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MessagesMenu',
  components: {
    MessageItem: __WEBPACK_IMPORTED_MODULE_2__MessageItem___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userInfo']))
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['notification']
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotificationItem__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotificationItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NotificationItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_firebaseApp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_filters__);








var db = __WEBPACK_IMPORTED_MODULE_3__helpers_firebaseApp__["a" /* firebaseApp */].database();
var sd202019Ref = db.ref('sd202019');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotificationsMenu',
  components: {
    NotificationItem: __WEBPACK_IMPORTED_MODULE_2__NotificationItem___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vue2_filters___default.a.mixin],
  data: function data() {
    return {
      tab: 'new',
      registros: []
    };
  },

  firebase: {
    registros: sd202019Ref
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userInfo']), {
    flag: function flag() {
      return this.$store.state.flag;
    },
    newNotifications: function newNotifications() {
      return this.userInfo.notifications.filter(function (n) {
        return !n.readAt;
      });
    },
    oldNotifications: function oldNotifications() {
      return this.userInfo.notifications.filter(function (n) {
        return n.readAt;
      });
    }
  }),
  methods: {
    markAllAsRead: function markAllAsRead() {
      event.stopPropagation();
      this.userInfo.notifications.filter(function (n) {
        return !n.readAt;
      }).forEach(function (notification) {
        notification.readAt = new Date().toUTCString;
      });
    },
    switchTab: function switchTab(event, tab) {
      event.stopPropagation();
      this.tab = tab;
    }
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SidebarMenu__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sidebar',
  props: ['displayName', 'pictureUrl'],
  components: { SidebarMenu: __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default.a },
  mounted: function mounted() {
    window.jQuery('[data-toggle="hideseek"]').off().hideseek();
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SidebarMenu',
  computed: {
    flag: function flag() {
      return this.$store.state.flag;
    }
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TasksMenu',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userInfo']))
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserMenu',
  props: ['user']
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_filters__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VAChart__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VAChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__VAChart__);






var db = __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__["a" /* firebaseApp */].database();
var sd202019Ref = db.ref('sd202019');

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue2_filters___default.a.mixin],
  data: function data() {
    return {
      registros: [],
      carregar: false,
      pesquisa: {
        titulo: 'titulo',
        parametro: 'DsPotenciaAcumuladaGerador',
        label: 'label'
      }
    };
  },

  components: {
    'va-chart': __WEBPACK_IMPORTED_MODULE_2__VAChart___default.a
  },
  firebase: {
    registros: sd202019Ref
  },
  methods: {
    track: function track() {
      this.$ga.page('/');
    },
    createRelatorioGeracaoSeteDias: function createRelatorioGeracaoSeteDias(pesquisa) {
      var _this = this;

      this.$store.dispatch('createRelatorioGeracaoSeteDias', pesquisa).then(function (response) {
        _this.carregar = true;
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    var bandeira = this.$store.state.flag;
    switch (bandeira) {
      case 'de':
        this.pesquisa.titulo = 'KW/h produziert ab Tag';
        this.pesquisa.label = 'Akkumulierte Generatorleistung';
        break;
      case 'us':
        this.pesquisa.titulo = 'KW/h produced from day';
        this.pesquisa.label = 'Accumulated Generator Power';
        break;
      case 'es':
        this.pesquisa.titulo = 'KW/h producidos a partir del día';
        this.pesquisa.label = 'Potencia acumulada del generador';
        break;
      default:
        this.pesquisa.titulo = 'KW/h produzidos a partir do dia';
        this.pesquisa.label = 'Potência Acumulada do Gerador teste';
        break;
    }
    this.createRelatorioGeracaoSeteDias(this.pesquisa);
  },

  computed: {
    producaoGrafico: function producaoGrafico() {
      return this.$store.state.Relatorios.historico;
    },
    flag: function flag() {
      return this.$store.state.flag;
    },
    producaoGraficoTitulo: function producaoGraficoTitulo() {
      return this.$store.state.Relatorios.titulo;
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VAChart__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VAChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__VAChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_firebaseApp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_filters__);







var db = __WEBPACK_IMPORTED_MODULE_3__helpers_firebaseApp__["a" /* firebaseApp */].database();
var sd202019Ref = db.ref('sd202019');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Graficos',
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vue2_filters___default.a.mixin],
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__["a" /* default */],
    'va-chart': __WEBPACK_IMPORTED_MODULE_2__VAChart___default.a
  },
  firebase: {
    registros: sd202019Ref
  },
  mounted: function mounted() {},

  computed: {
    producaoGrafico: function producaoGrafico() {
      return this.$store.state.Relatorios.historico;
    },
    flag: function flag() {
      return this.$store.state.flag;
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  },
  data: function data() {
    return {
      ptBR: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["ptBR"],
      en: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["en"],
      es: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["es"],
      de: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["de"],
      registros: {},
      showDismissibleAlert: false,
      messageAlert: '',
      dataInicioBusca: '',
      dataFimBusca: '',
      parametro: '',
      pesquisa: {
        dataInicioBusca: '',
        dataFimBusca: '',
        parametro: '',
        label: ''
      },
      exibirGrafico: false,
      errors: []
    };
  },

  methods: {
    debug: function debug(parametro, label) {
      console.log('Debug parametro: ' + parametro);
      console.log('Debug label: ' + label);
    },
    showAlert: function showAlert(titulo, mensagem, tipoMensagem, exibeBotao, textoBotao) {
      this.$swal({
        title: titulo,
        text: mensagem,
        icon: tipoMensagem,
        showConfirmButton: exibeBotao,
        confirmButtonText: textoBotao
      });
    },

    efetuarPesquisa: function efetuarPesquisa(bandeira) {
      var _this = this;

      var DadosInvalidos = 'DadosInvalidos';
      var DataVazia = 'DataVazia';
      var DataFinalAnterior = 'DataFinalAnterior';
      var SelecionarParametro = 'SelecionarParametro';
      var EnviandoDados = 'EnviandoDados';
      var AguardeGerar = 'AguardeGerar';
      var TituloGrafico = 'TituloGrafico';
      switch (bandeira) {
        case 'br':
          DadosInvalidos = 'Dados inválidos!';
          DataVazia = 'Não pode ter data vazia!';
          DataFinalAnterior = 'Data final não pode ser anterior à data inicial!';
          SelecionarParametro = 'Favor selecionar um parâmetro de pesquisa!';
          EnviandoDados = 'Enviando dados!';
          AguardeGerar = 'Aguarde enquanto o gráfico está sendo gerado!';
          break;
        case 'de':
          DadosInvalidos = 'Ungültige Daten!';
          DataVazia = 'Kann kein leeres Datum haben!';
          DataFinalAnterior = 'Das Enddatum darf nicht vor dem Startdatum liegen!';
          SelecionarParametro = 'Bitte wählen Sie einen Suchparameter!';
          EnviandoDados = 'Daten senden!';
          AguardeGerar = 'Warten Sie, während das Diagramm generiert wird!';
          break;
        case 'us':
          DadosInvalidos = 'Invalid data!';
          DataVazia = 'Cannot have empty date!';
          DataFinalAnterior = 'End date cannot be earlier than start date!';
          SelecionarParametro = 'Please select a search parameter!';
          EnviandoDados = 'Sending data!';
          AguardeGerar = 'Wait while the chart is being generated!';
          break;
        default:
          DadosInvalidos = 'Datos inválidos!';
          DataVazia = '¡No se puede tener una fecha vacía!';
          DataFinalAnterior = '¡La fecha de finalización no puede ser anterior a la fecha de inicio!';
          SelecionarParametro = 'Por favor, seleccione un parámetro de búsqueda!';
          EnviandoDados = 'Enviando datos!';
          AguardeGerar = '¡Espere mientras se genera el gráfico!';
          break;
      }
      this.exibirGrafico = false;
      if (this.dataInicioBusca === '' || this.dataFimBusca === '') {
        this.showAlert(DadosInvalidos, DataVazia, 'warning', true, 'Ok');
      } else if (this.dataInicioBusca > this.dataFimBusca) {
        this.showAlert(DadosInvalidos, DataFinalAnterior, 'warning', true, 'Ok');
      } else if (this.parametro === '') {
        this.showAlert(DadosInvalidos, SelecionarParametro, 'warning', true, 'Ok');
      } else {
        this.showAlert(EnviandoDados, AguardeGerar, 'info', false, 'Ok');
        this.showDismissibleAlert = false;
        this.pesquisa.dataInicioBusca = this.dataInicioBusca.toISOString().substring(0, 10);
        this.pesquisa.dataFimBusca = this.dataFimBusca.toISOString().substring(0, 10);
        this.pesquisa.parametro = this.parametro.$key;
        switch (bandeira) {
          case 'br':
            TituloGrafico = this.parametro.$value.labelPtBr;
            break;
          case 'de':
            TituloGrafico = this.parametro.$value.labelDe;
            break;
          case 'us':
            TituloGrafico = this.parametro.$value.labelEn;
            break;
          default:
            TituloGrafico = this.parametro.$value.labelEs;
            break;
        }
        this.pesquisa.label = TituloGrafico + ' (' + this.parametro.$value.unidade_medida + ') ';
        this.$store.dispatch('createRelatorioHistorico', this.pesquisa).then(function (response) {
          _this.$swal.close();
          _this.exibirGrafico = true;
        }).catch(function (e) {
          _this.errors.push(e);
        });
      }
    }
  }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VAChart__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VAChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__VAChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_firebaseApp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_filters__);







var db = __WEBPACK_IMPORTED_MODULE_3__helpers_firebaseApp__["a" /* firebaseApp */].database();
var sd202019Ref = db.ref('sd202019');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RelatoriosAcumulados',
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vue2_filters___default.a.mixin],
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__["a" /* default */],
    'va-chart': __WEBPACK_IMPORTED_MODULE_2__VAChart___default.a
  },
  firebase: {
    registros: sd202019Ref
  },
  mounted: function mounted() {},

  computed: {
    producaoGrafico: function producaoGrafico() {
      return this.$store.state.Relatorios.acumulado;
    },
    flag: function flag() {
      return this.$store.state.flag;
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  },
  data: function data() {
    return {
      ptBR: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["ptBR"],
      en: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["en"],
      es: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["es"],
      de: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["de"],
      registros: {},
      showDismissibleAlert: false,
      messageAlert: '',
      dataInicioBusca: '',
      dataFimBusca: '',
      parametro: '',
      pesquisa: {
        dataInicioBusca: '',
        dataFimBusca: '',
        parametro: '',
        label: ''
      },
      exibirGrafico: false,
      errors: []
    };
  },

  methods: {
    debug: function debug(parametro, label) {
      console.log('Debug parametro: ' + parametro);
      console.log('Debug label: ' + label);
    },
    showAlert: function showAlert(titulo, mensagem, tipoMensagem, exibeBotao, textoBotao) {
      this.$swal({
        title: titulo,
        text: mensagem,
        icon: tipoMensagem,
        showConfirmButton: exibeBotao,
        confirmButtonText: textoBotao
      });
    },

    efetuarPesquisa: function efetuarPesquisa(bandeira) {
      var _this = this;

      var DadosInvalidos = 'DadosInvalidos';
      var DataVazia = 'DataVazia';
      var DataFinalAnterior = 'DataFinalAnterior';
      var SelecionarParametro = 'SelecionarParametro';
      var EnviandoDados = 'EnviandoDados';
      var AguardeGerar = 'AguardeGerar';
      var TituloGrafico = 'TituloGrafico';
      switch (bandeira) {
        case 'br':
          DadosInvalidos = 'Dados inválidos!';
          DataVazia = 'Não pode ter data vazia!';
          DataFinalAnterior = 'Data final não pode ser anterior à data inicial!';
          SelecionarParametro = 'Favor selecionar um parâmetro de pesquisa!';
          EnviandoDados = 'Enviando dados!';
          AguardeGerar = 'Aguarde enquanto o gráfico está sendo gerado!';
          break;
        case 'de':
          DadosInvalidos = 'Ungültige Daten!';
          DataVazia = 'Kann kein leeres Datum haben!';
          DataFinalAnterior = 'Das Enddatum darf nicht vor dem Startdatum liegen!';
          SelecionarParametro = 'Bitte wählen Sie einen Suchparameter!';
          EnviandoDados = 'Daten senden!';
          AguardeGerar = 'Warten Sie, während das Diagramm generiert wird!';
          break;
        case 'us':
          DadosInvalidos = 'Invalid data!';
          DataVazia = 'Cannot have empty date!';
          DataFinalAnterior = 'End date cannot be earlier than start date!';
          SelecionarParametro = 'Please select a search parameter!';
          EnviandoDados = 'Sending data!';
          AguardeGerar = 'Wait while the chart is being generated!';
          break;
        default:
          DadosInvalidos = 'Datos inválidos!';
          DataVazia = '¡No se puede tener una fecha vacía!';
          DataFinalAnterior = '¡La fecha de finalización no puede ser anterior a la fecha de inicio!';
          SelecionarParametro = 'Por favor, seleccione un parámetro de búsqueda!';
          EnviandoDados = 'Enviando datos!';
          AguardeGerar = '¡Espere mientras se genera el gráfico!';
          break;
      }
      this.exibirGrafico = false;
      if (this.dataInicioBusca === '' || this.dataFimBusca === '') {
        this.showAlert(DadosInvalidos, DataVazia, 'warning', true, 'Ok');
      } else if (this.dataInicioBusca > this.dataFimBusca) {
        this.showAlert(DadosInvalidos, DataFinalAnterior, 'warning', true, 'Ok');
      } else if (this.parametro === '') {
        this.showAlert(DadosInvalidos, SelecionarParametro, 'warning', true, 'Ok');
      } else {
        this.showAlert(EnviandoDados, AguardeGerar, 'info', false, 'Ok');
        this.showDismissibleAlert = false;
        this.pesquisa.dataInicioBusca = this.dataInicioBusca.toISOString().substring(0, 10);
        this.pesquisa.dataFimBusca = this.dataFimBusca.toISOString().substring(0, 10);
        this.pesquisa.parametro = this.parametro.$key;
        switch (bandeira) {
          case 'br':
            TituloGrafico = this.parametro.$value.labelPtBr;
            break;
          case 'de':
            TituloGrafico = this.parametro.$value.labelDe;
            break;
          case 'us':
            TituloGrafico = this.parametro.$value.labelEn;
            break;
          default:
            TituloGrafico = this.parametro.$value.labelEs;
            break;
        }
        this.pesquisa.label = TituloGrafico + ' (' + this.parametro.$value.unidade_medida + ') ';
        this.$store.dispatch('createRelatorioAcumuladoDias', this.pesquisa).then(function (response) {
          _this.$swal.close();
          _this.exibirGrafico = true;
        }).catch(function (e) {
          _this.errors.push(e);
        });
      }
    }
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VAChart__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VAChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__VAChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_firebaseApp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_filters__);







var db = __WEBPACK_IMPORTED_MODULE_3__helpers_firebaseApp__["a" /* firebaseApp */].database();
var sd202019Ref = db.ref('sd202019');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RelatoriosMaterial',
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vue2_filters___default.a.mixin],
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__["a" /* default */],
    'va-chart': __WEBPACK_IMPORTED_MODULE_2__VAChart___default.a
  },
  firebase: {
    registros: sd202019Ref
  },
  mounted: function mounted() {},

  computed: {
    producaoGrafico: function producaoGrafico() {
      return this.$store.state.Relatorios.historico;
    },
    flag: function flag() {
      return this.$store.state.flag;
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  },
  data: function data() {
    return {
      ptBR: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["ptBR"],
      en: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["en"],
      es: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["es"],
      de: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["de"],
      registros: {},
      showDismissibleAlert: false,
      messageAlert: '',
      dataInicioBusca: '',
      dataFimBusca: '',
      parametro: '',
      pesquisa: {
        dataInicioBusca: '',
        dataFimBusca: '',
        parametro: '',
        label: ''
      },
      exibirGrafico: false,
      errors: []
    };
  },

  methods: {
    debug: function debug(parametro, label) {
      console.log('Debug parametro: ' + parametro);
      console.log('Debug label: ' + label);
    },
    showAlert: function showAlert(titulo, mensagem, tipoMensagem, exibeBotao, textoBotao) {
      this.$swal({
        title: titulo,
        text: mensagem,
        icon: tipoMensagem,
        showConfirmButton: exibeBotao,
        confirmButtonText: textoBotao
      });
    },

    efetuarPesquisa: function efetuarPesquisa(bandeira) {
      var _this = this;

      var DadosInvalidos = 'DadosInvalidos';
      var DataVazia = 'DataVazia';
      var DataFinalAnterior = 'DataFinalAnterior';
      var SelecionarParametro = 'SelecionarParametro';
      var EnviandoDados = 'EnviandoDados';
      var AguardeGerar = 'AguardeGerar';
      var TituloGrafico = 'TituloGrafico';
      switch (bandeira) {
        case 'br':
          DadosInvalidos = 'Dados inválidos!';
          DataVazia = 'Não pode ter data vazia!';
          DataFinalAnterior = 'Data final não pode ser anterior à data inicial!';
          SelecionarParametro = 'Favor selecionar um parâmetro de pesquisa!';
          EnviandoDados = 'Enviando dados!';
          AguardeGerar = 'Aguarde enquanto o gráfico está sendo gerado!';
          break;
        case 'de':
          DadosInvalidos = 'Ungültige Daten!';
          DataVazia = 'Kann kein leeres Datum haben!';
          DataFinalAnterior = 'Das Enddatum darf nicht vor dem Startdatum liegen!';
          SelecionarParametro = 'Bitte wählen Sie einen Suchparameter!';
          EnviandoDados = 'Daten senden!';
          AguardeGerar = 'Warten Sie, während das Diagramm generiert wird!';
          break;
        case 'us':
          DadosInvalidos = 'Invalid data!';
          DataVazia = 'Cannot have empty date!';
          DataFinalAnterior = 'End date cannot be earlier than start date!';
          SelecionarParametro = 'Please select a search parameter!';
          EnviandoDados = 'Sending data!';
          AguardeGerar = 'Wait while the chart is being generated!';
          break;
        default:
          DadosInvalidos = 'Datos inválidos!';
          DataVazia = '¡No se puede tener una fecha vacía!';
          DataFinalAnterior = '¡La fecha de finalización no puede ser anterior a la fecha de inicio!';
          SelecionarParametro = 'Por favor, seleccione un parámetro de búsqueda!';
          EnviandoDados = 'Enviando datos!';
          AguardeGerar = '¡Espere mientras se genera el gráfico!';
          break;
      }
      this.exibirGrafico = false;
      if (this.dataInicioBusca === '' || this.dataFimBusca === '') {
        this.showAlert(DadosInvalidos, DataVazia, 'warning', true, 'Ok');
      } else if (this.dataInicioBusca > this.dataFimBusca) {
        this.showAlert(DadosInvalidos, DataFinalAnterior, 'warning', true, 'Ok');
      } else if (this.parametro === '') {
        this.showAlert(DadosInvalidos, SelecionarParametro, 'warning', true, 'Ok');
      } else {
        console.log('passou batido');
        this.showAlert(EnviandoDados, AguardeGerar, 'info', false, 'Ok');
        this.showDismissibleAlert = false;
        this.pesquisa.dataInicioBusca = this.dataInicioBusca.toISOString().substring(0, 10);
        this.pesquisa.dataFimBusca = this.dataFimBusca.toISOString().substring(0, 10);
        this.pesquisa.parametro = this.parametro.$key;
        switch (bandeira) {
          case 'br':
            TituloGrafico = this.parametro.$value.labelPtBr;
            break;
          case 'de':
            TituloGrafico = this.parametro.$value.labelDe;
            break;
          case 'us':
            TituloGrafico = this.parametro.$value.labelEn;
            break;
          default:
            TituloGrafico = this.parametro.$value.labelEs;
            break;
        }
        this.pesquisa.label = TituloGrafico + ' (' + this.parametro.$value.unidade_medida + ') ';
        this.$store.dispatch('createRelatorioHistorico', this.pesquisa).then(function (response) {
          _this.$swal.close();
          _this.exibirGrafico = true;
        }).catch(function (e) {
          _this.errors.push(e);
        });
      }
    }
  }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_filters__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_filters__);





var db = __WEBPACK_IMPORTED_MODULE_0__helpers_firebaseApp__["a" /* firebaseApp */].database();
var sd202019Ref = db.ref('sd202019');

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue2_filters___default.a.mixin],
  data: function data() {
    return {
      registros: [],
      generateRandomNumbers: function generateRandomNumbers(numbers, max, min) {
        var a = [];
        for (var i = 0; i < numbers; i++) {
          a.push(Math.floor(Math.random() * (max - min + 1)) + max);
        }
        return a;
      }
    };
  },

  firebase: {
    registros: sd202019Ref
  },
  computed: {
    flag: function flag() {
      return this.$store.state.flag;
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_firebaseApp__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'usuario',
  mounted: function mounted() {
    this.buscarUsuario();
  },

  computed: {
    flag: function flag() {
      return this.$store.state.flag;
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    }
  },
  data: function data() {
    return {
      displayNameNew: ''
    };
  },

  methods: {
    track: function track() {
      this.$ga.page('/usuario');
    },
    showAlert: function showAlert(titulo, mensagem, tipoMensagem, exibeBotao, textoBotao) {
      this.$swal({
        title: titulo,
        icon: mensagem,
        type: tipoMensagem,
        showConfirmButton: exibeBotao,
        confirmButtonText: textoBotao
      });
    },

    buscarUsuario: function buscarUsuario() {
      this.displayNameNew = this.$store.state.user.displayName;
    },
    alterarNomeUsuario: function alterarNomeUsuario() {
      var NomeAlterado = 'NomeAlterado';
      var FavorLogar = 'FavorLogar';
      var NaoAtendida = 'NaoAtendida';
      var FalhaNome = 'FalhaNome';
      var bandeira = this.$store.state.flag;
      switch (bandeira) {
        case 'de':
          NomeAlterado = 'Name erfolgreich geändert!';
          FavorLogar = 'Bitte melden Sie sich erneut an, damit die Änderungen angezeigt werden!';
          NaoAtendida = 'Anfrage verpasst!';
          FalhaNome = 'Änderung des Namens fehlgeschlagen!';
          break;
        case 'us':
          NomeAlterado = 'Name changed successfully!';
          FavorLogar = 'Please log in again for changes to be displayed!';
          NaoAtendida = 'Request missed!';
          FalhaNome = 'Failed to change name!';
          break;
        case 'br':
          NomeAlterado = 'Nombre cambiado con éxito!';
          FavorLogar = '¡Vuelva a iniciar sesión para que se muestren los cambios!';
          NaoAtendida = 'Solicitud perdida!';
          FalhaNome = '¡No se pudo cambiar el nombre!';
          break;
        default:
          NomeAlterado = 'Nome alterado com sucesso!';
          FavorLogar = 'Favor logar novamente para as alterações serem exibidas!';
          NaoAtendida = 'Solicitação não atendida!';
          FalhaNome = 'Falha ao alterar o nome!';
          break;
      }
      var user = __WEBPACK_IMPORTED_MODULE_1__helpers_firebaseApp__["a" /* firebaseApp */].auth().currentUser;
      var confirmar = user.updateProfile({
        displayName: this.displayNameNew
      }).then(function () {
        this.$store.commit('SET_USER', __WEBPACK_IMPORTED_MODULE_1__helpers_firebaseApp__["a" /* firebaseApp */].auth().currentUser);
        window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_1__helpers_firebaseApp__["a" /* firebaseApp */].auth().currentUser));
        return true;
      }).catch(function (error) {
        console.log(error);
        return false;
      });
      if (confirmar) {
        this.showAlert(NomeAlterado, FavorLogar, 'info', true, 'Ok');
      } else {
        this.showAlert(NaoAtendida, FalhaNome, 'warning', true, 'Ok');
      }
    },
    alterarSenhaUsuario: function alterarSenhaUsuario() {
      var NaoAtendida = 'NaoAtendida';
      var Atendida = 'Atendida';
      var EmailEnviado = 'EmailEnviado';
      var EmailFalha = 'EmailFalha';
      var bandeira = this.$store.state.flag;
      switch (bandeira) {
        case 'de':
          NaoAtendida = 'Anfrage verpasst!';
          Atendida = 'Anfrage erfolgreich gestellt!';
          EmailEnviado = 'E-Mail zum Zurücksetzen des Passworts gesendet an ';
          EmailFalha = 'Fehler beim Senden der E-Mail zum Zurücksetzen des Kennworts an ';
          break;
        case 'us':
          NaoAtendida = 'Request missed!';
          Atendida = 'Request made successfully!';
          EmailEnviado = 'Password reset email sent to ';
          EmailFalha = 'Failed to send password reset email to ';
          break;
        case 'es':
          NaoAtendida = 'Solicitud perdida!';
          Atendida = 'Solicitud realizada con éxito!';
          EmailEnviado = 'Correo electrónico de restablecimiento de contraseña enviado a ';
          EmailFalha = 'Error al enviar el correo electrónico de restablecimiento de contraseña a ';
          break;
        default:
          NaoAtendida = 'Solicitação não atendida!';
          Atendida = 'Solicitação efetuada com Sucesso!';
          EmailEnviado = 'Email de redefinição de senha enviado para ';
          EmailFalha = 'Falha ao enviar email de redefinição de senha para ';
          break;
      }
      var auth = __WEBPACK_IMPORTED_MODULE_1__helpers_firebaseApp__["a" /* firebaseApp */].auth();
      var emailAddress = this.$store.state.user.email;
      var confirmar = auth.sendPasswordResetEmail(emailAddress).then(function () {
        return true;
      }).catch(function (error) {
        console.log(error);
        return false;
      });
      if (confirmar) {
        this.showAlert(Atendida, EmailEnviado + emailAddress, 'info', true, 'Ok');
      } else {
        this.showAlert(NaoAtendida, EmailFalha + emailAddress, 'warning', true, 'Ok');
      }
    }
  }
});

/***/ }),
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 301 */,
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 34,
	"./af.js": 34,
	"./ar": 41,
	"./ar-dz": 35,
	"./ar-dz.js": 35,
	"./ar-kw": 36,
	"./ar-kw.js": 36,
	"./ar-ly": 37,
	"./ar-ly.js": 37,
	"./ar-ma": 38,
	"./ar-ma.js": 38,
	"./ar-sa": 39,
	"./ar-sa.js": 39,
	"./ar-tn": 40,
	"./ar-tn.js": 40,
	"./ar.js": 41,
	"./az": 42,
	"./az.js": 42,
	"./be": 43,
	"./be.js": 43,
	"./bg": 44,
	"./bg.js": 44,
	"./bm": 45,
	"./bm.js": 45,
	"./bn": 46,
	"./bn.js": 46,
	"./bo": 47,
	"./bo.js": 47,
	"./br": 48,
	"./br.js": 48,
	"./bs": 49,
	"./bs.js": 49,
	"./ca": 50,
	"./ca.js": 50,
	"./cs": 51,
	"./cs.js": 51,
	"./cv": 52,
	"./cv.js": 52,
	"./cy": 53,
	"./cy.js": 53,
	"./da": 54,
	"./da.js": 54,
	"./de": 57,
	"./de-at": 55,
	"./de-at.js": 55,
	"./de-ch": 56,
	"./de-ch.js": 56,
	"./de.js": 57,
	"./dv": 58,
	"./dv.js": 58,
	"./el": 59,
	"./el.js": 59,
	"./en-au": 60,
	"./en-au.js": 60,
	"./en-ca": 61,
	"./en-ca.js": 61,
	"./en-gb": 62,
	"./en-gb.js": 62,
	"./en-ie": 63,
	"./en-ie.js": 63,
	"./en-nz": 64,
	"./en-nz.js": 64,
	"./eo": 65,
	"./eo.js": 65,
	"./es": 68,
	"./es-do": 66,
	"./es-do.js": 66,
	"./es-us": 67,
	"./es-us.js": 67,
	"./es.js": 68,
	"./et": 69,
	"./et.js": 69,
	"./eu": 70,
	"./eu.js": 70,
	"./fa": 71,
	"./fa.js": 71,
	"./fi": 72,
	"./fi.js": 72,
	"./fo": 73,
	"./fo.js": 73,
	"./fr": 76,
	"./fr-ca": 74,
	"./fr-ca.js": 74,
	"./fr-ch": 75,
	"./fr-ch.js": 75,
	"./fr.js": 76,
	"./fy": 77,
	"./fy.js": 77,
	"./gd": 78,
	"./gd.js": 78,
	"./gl": 79,
	"./gl.js": 79,
	"./gom-latn": 80,
	"./gom-latn.js": 80,
	"./gu": 81,
	"./gu.js": 81,
	"./he": 82,
	"./he.js": 82,
	"./hi": 83,
	"./hi.js": 83,
	"./hr": 84,
	"./hr.js": 84,
	"./hu": 85,
	"./hu.js": 85,
	"./hy-am": 86,
	"./hy-am.js": 86,
	"./id": 87,
	"./id.js": 87,
	"./is": 88,
	"./is.js": 88,
	"./it": 89,
	"./it.js": 89,
	"./ja": 90,
	"./ja.js": 90,
	"./jv": 91,
	"./jv.js": 91,
	"./ka": 92,
	"./ka.js": 92,
	"./kk": 93,
	"./kk.js": 93,
	"./km": 94,
	"./km.js": 94,
	"./kn": 95,
	"./kn.js": 95,
	"./ko": 96,
	"./ko.js": 96,
	"./ky": 97,
	"./ky.js": 97,
	"./lb": 98,
	"./lb.js": 98,
	"./lo": 99,
	"./lo.js": 99,
	"./lt": 100,
	"./lt.js": 100,
	"./lv": 101,
	"./lv.js": 101,
	"./me": 102,
	"./me.js": 102,
	"./mi": 103,
	"./mi.js": 103,
	"./mk": 104,
	"./mk.js": 104,
	"./ml": 105,
	"./ml.js": 105,
	"./mr": 106,
	"./mr.js": 106,
	"./ms": 108,
	"./ms-my": 107,
	"./ms-my.js": 107,
	"./ms.js": 108,
	"./mt": 109,
	"./mt.js": 109,
	"./my": 110,
	"./my.js": 110,
	"./nb": 111,
	"./nb.js": 111,
	"./ne": 112,
	"./ne.js": 112,
	"./nl": 114,
	"./nl-be": 113,
	"./nl-be.js": 113,
	"./nl.js": 114,
	"./nn": 115,
	"./nn.js": 115,
	"./pa-in": 116,
	"./pa-in.js": 116,
	"./pl": 117,
	"./pl.js": 117,
	"./pt": 119,
	"./pt-br": 118,
	"./pt-br.js": 118,
	"./pt.js": 119,
	"./ro": 120,
	"./ro.js": 120,
	"./ru": 121,
	"./ru.js": 121,
	"./sd": 122,
	"./sd.js": 122,
	"./se": 123,
	"./se.js": 123,
	"./si": 124,
	"./si.js": 124,
	"./sk": 125,
	"./sk.js": 125,
	"./sl": 126,
	"./sl.js": 126,
	"./sq": 127,
	"./sq.js": 127,
	"./sr": 129,
	"./sr-cyrl": 128,
	"./sr-cyrl.js": 128,
	"./sr.js": 129,
	"./ss": 130,
	"./ss.js": 130,
	"./sv": 131,
	"./sv.js": 131,
	"./sw": 132,
	"./sw.js": 132,
	"./ta": 133,
	"./ta.js": 133,
	"./te": 134,
	"./te.js": 134,
	"./tet": 135,
	"./tet.js": 135,
	"./th": 136,
	"./th.js": 136,
	"./tl-ph": 137,
	"./tl-ph.js": 137,
	"./tlh": 138,
	"./tlh.js": 138,
	"./tr": 139,
	"./tr.js": 139,
	"./tzl": 140,
	"./tzl.js": 140,
	"./tzm": 142,
	"./tzm-latn": 141,
	"./tzm-latn.js": 141,
	"./tzm.js": 142,
	"./uk": 143,
	"./uk.js": 143,
	"./ur": 144,
	"./ur.js": 144,
	"./uz": 146,
	"./uz-latn": 145,
	"./uz-latn.js": 145,
	"./uz.js": 146,
	"./vi": 147,
	"./vi.js": 147,
	"./x-pseudo": 148,
	"./x-pseudo.js": 148,
	"./yo": 149,
	"./yo.js": 149,
	"./zh-cn": 150,
	"./zh-cn.js": 150,
	"./zh-hk": 151,
	"./zh-hk.js": 151,
	"./zh-tw": 152,
	"./zh-tw.js": 152
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 302;

/***/ }),
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(288)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(333),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(297)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(347),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(296)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(346),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(290)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(336),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(330),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(335),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(287)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(332),
  /* scopeId */
  "data-v-2cbcd03c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(285)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(329),
  /* scopeId */
  "data-v-0fcc4b82",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(344),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(299)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(349),
  /* scopeId */
  "data-v-f6aac0a2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(291)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(337),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(293)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(339),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(342),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(340),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(286)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(331),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(295)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(345),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(294)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(343),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(298)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(348),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(284)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(328),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(292)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(338),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30px"
    }
  }, [_vm._v("#")]), _vm._v(" "), (_vm.flag === 'br') ? _c('th', [_vm._v("Parâmetro")]) : (_vm.flag === 'de') ? _c('th', [_vm._v("Parameter")]) : (_vm.flag === 'us') ? _c('th', [_vm._v("Parameter")]) : _c('th', [_vm._v("Parámetro")]), _vm._v(" "), (_vm.flag === 'br') ? _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Valor")]) : (_vm.flag === 'de') ? _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Wert")]) : (_vm.flag === 'us') ? _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Value")]) : _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Valor")])])]), _vm._v(" "), _c('tbody', [(_vm.flag === 'br') ? _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_bool'), false, 'is_alarme'), 'labelPtBr')), function(registro) {
    return (registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelPtBr))]), _vm._v(" "), _c('td', [_c('div', [(registro.valor === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-up "
    })]) : _c('span', {
      staticClass: "badge bg-red"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-down"
    })])])])]) : _vm._e()
  }) : (_vm.flag === 'de') ? _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_bool'), false, 'is_alarme'), 'labelDe')), function(registro) {
    return (registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelDe))]), _vm._v(" "), _c('td', [_c('div', [(registro.valor === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-up "
    })]) : _c('span', {
      staticClass: "badge bg-red"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-down"
    })])])])]) : _vm._e()
  }) : (_vm.flag === 'us') ? _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_bool'), false, 'is_alarme'), 'labelEn')), function(registro) {
    return (registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelEn))]), _vm._v(" "), _c('td', [_c('div', [(registro.valor === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-up "
    })]) : _c('span', {
      staticClass: "badge bg-red"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-down"
    })])])])]) : _vm._e()
  }) : _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_bool'), false, 'is_alarme'), 'labelEs')), function(registro) {
    return (registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelEs))]), _vm._v(" "), _c('td', [_c('div', [(registro.valor === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-up "
    })]) : _c('span', {
      staticClass: "badge bg-red"
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-down"
    })])])])]) : _vm._e()
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30px"
    }
  }, [_vm._v("#")]), _vm._v(" "), (_vm.flag === 'br') ? _c('th', [_vm._v("Parâmetro")]) : (_vm.flag === 'de') ? _c('th', [_vm._v("Parameter")]) : (_vm.flag === 'us') ? _c('th', [_vm._v("Parameter")]) : _c('th', [_vm._v("Parámetro")]), _vm._v(" "), (_vm.flag === 'br') ? _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Valor")]) : (_vm.flag === 'de') ? _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Wert")]) : (_vm.flag === 'us') ? _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Value")]) : _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Valor")]), _vm._v(" "), (_vm.flag === 'br') ? _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Histórico")]) : (_vm.flag === 'de') ? _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Geschichte")]) : (_vm.flag === 'us') ? _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Historic")]) : _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Historia")])])]), _vm._v(" "), _c('tbody', [(_vm.flag === 'br') ? _vm._l((_vm.orderBy(_vm.registros, 'labelPtBr')), function(registro) {
    return (!registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelPtBr))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "float-right"
    }, [_c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v("\n                         " + _vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    })) + " " + _vm._s(registro.unidade_medida) + "\n                        ")])])]), _vm._v(" "), _c('td', [_c('div', [(registro.registrado == true) ? _c('span', {
      staticClass: "badge bg-teal"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]) : _vm._e()])])]) : _vm._e()
  }) : (_vm.flag === 'de') ? _vm._l((_vm.orderBy(_vm.registros, 'labelDe')), function(registro) {
    return (!registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelDe))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "float-right"
    }, [_c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v("\n                         " + _vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    })) + " " + _vm._s(registro.unidade_medida) + "\n                        ")])])]), _vm._v(" "), _c('td', [_c('div', [(registro.registrado == true) ? _c('span', {
      staticClass: "badge bg-teal"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]) : _vm._e()])])]) : _vm._e()
  }) : (_vm.flag === 'us') ? _vm._l((_vm.orderBy(_vm.registros, 'labelEn')), function(registro) {
    return (!registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelEn))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "float-right"
    }, [_c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v("\n                         " + _vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    })) + " " + _vm._s(registro.unidade_medida) + "\n                        ")])])]), _vm._v(" "), _c('td', [_c('div', [(registro.registrado == true) ? _c('span', {
      staticClass: "badge bg-teal"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]) : _vm._e()])])]) : _vm._e()
  }) : _vm._l((_vm.orderBy(_vm.registros, 'labelEs')), function(registro) {
    return (!registro.is_bool) ? _c('tr', {
      key: registro.id
    }, [_c('td', [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(registro.labelEs))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "float-right"
    }, [_c('span', {
      staticClass: "text-uppercase"
    }, [_vm._v("\n                         " + _vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    })) + " " + _vm._s(registro.unidade_medida) + "\n                        ")])])]), _vm._v(" "), _c('td', [_c('div', [(registro.registrado == true) ? _c('span', {
      staticClass: "badge bg-teal"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]) : _vm._e()])])]) : _vm._e()
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-sm-block"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},staticRenderFns: []}

/***/ }),
/* 329 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('h4', [_c('span', [_vm._v(_vm._s(_vm.message.title))]), _vm._v(" "), _c('small', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.message.createdAt))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.message.body))])])])
},staticRenderFns: []}

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + "\n    "), _c('a', {
    attrs: {
      "href": "https://www.solidtectecnologia.com.br"
    }
  }, [_vm._v("Solidtec Tecnologia")])]), _vm._v(" "), (_vm.flag === 'es') ? _c('span', [_vm._v(". Todos los derechos reservados.")]) : (_vm.flag === 'de') ? _c('span', [_vm._v(". Alle rechte vorbehalten.")]) : (_vm.flag === 'us') ? _c('span', [_vm._v(". All rights reserved.")]) : _c('span', [_vm._v(". Todos os direitos reservados.")])])
},staticRenderFns: []}

/***/ }),
/* 331 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flag === 'br') ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.orderBy(_vm.registros, 'labelPtBr')), function(registro) {
    return (registro.exibir) ? _c('div', {
      key: registro.id,
      staticClass: "col-md-3 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "info-box bg-yellow"
    }, [_c('span', {
      staticClass: "info-box-icon"
    }, [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-box-content"
    }, [_c('span', {
      staticClass: "info-box-text"
    }, [_vm._v(_vm._s(registro.labelPtBr))]), _vm._v(" "), (!registro.is_bool) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v(_vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    }))), _c('small', [_vm._v(" " + _vm._s(registro.unidade_medida))])]) : (registro.valor) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("Off")]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('span', {
      staticClass: "progress-description"
    }, [_vm._v("\n               " + _vm._s(registro.data_atualizacao) + "\n             ")])])])]) : _vm._e()
  })) : (_vm.flag === 'de') ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.orderBy(_vm.registros, 'labelDe')), function(registro) {
    return (registro.exibir) ? _c('div', {
      key: registro.id,
      staticClass: "col-md-3 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "info-box bg-yellow"
    }, [_c('span', {
      staticClass: "info-box-icon"
    }, [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-box-content"
    }, [_c('span', {
      staticClass: "info-box-text"
    }, [_vm._v(_vm._s(registro.labelDe))]), _vm._v(" "), (!registro.is_bool) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v(_vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    }))), _c('small', [_vm._v(" " + _vm._s(registro.unidade_medida))])]) : (registro.valor) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("Off")]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('span', {
      staticClass: "progress-description"
    }, [_vm._v("\n               " + _vm._s(registro.data_atualizacao) + "\n             ")])])])]) : _vm._e()
  })) : (_vm.flag === 'us') ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.orderBy(_vm.registros, 'labelEn')), function(registro) {
    return (registro.exibir) ? _c('div', {
      key: registro.id,
      staticClass: "col-md-3 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "info-box bg-yellow"
    }, [_c('span', {
      staticClass: "info-box-icon"
    }, [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-box-content"
    }, [_c('span', {
      staticClass: "info-box-text"
    }, [_vm._v(_vm._s(registro.labelEn))]), _vm._v(" "), (!registro.is_bool) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v(_vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    }))), _c('small', [_vm._v(" " + _vm._s(registro.unidade_medida))])]) : (registro.valor) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("Off")]), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('span', {
      staticClass: "progress-description"
    }, [_vm._v("\n               " + _vm._s(registro.data_atualizacao) + "\n             ")])])])]) : _vm._e()
  })) : _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.orderBy(_vm.registros, 'labelEs')), function(registro) {
    return (registro.exibir) ? _c('div', {
      key: registro.id,
      staticClass: "col-md-3 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "info-box bg-yellow"
    }, [_c('span', {
      staticClass: "info-box-icon"
    }, [_c('i', {
      class: registro.icone
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-box-content"
    }, [_c('span', {
      staticClass: "info-box-text"
    }, [_vm._v(_vm._s(registro.labelEs))]), _vm._v(" "), (!registro.is_bool) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v(_vm._s(_vm._f("currency")(registro.valor, '', 2, {
      thousandsSeparator: '.',
      decimalSeparator: ','
    }))), _c('small', [_vm._v(" " + _vm._s(registro.unidade_medida))])]) : (registro.valor) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("On")]) : _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v("Off")]), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _c('span', {
      staticClass: "progress-description"
    }, [_vm._v("\n               " + _vm._s(registro.data_atualizacao) + "\n             ")])])])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-sm-block"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm.producaoGraficoTitulo))])]), _vm._v(" "), (_vm.carregar) ? _c('va-chart', {
    attrs: {
      "chart-config": _vm.producaoGrafico
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('hr', {
    staticClass: "visible-xs-block"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "100%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "100%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "100%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "100%"
    }
  })])
}]}

/***/ }),
/* 332 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown notifications-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('country-flag', {
    attrs: {
      "country": _vm.flag,
      "size": "small"
    }
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "row no-margin"
  }, [_c('span', {
    staticClass: "col-xs-12 col-md-6 tab-link",
    on: {
      "click": function($event) {
        _vm.switchLang('es')
      }
    }
  }, [_c('country-flag', {
    attrs: {
      "country": "es",
      "size": "small"
    }
  }), _vm._v(" Español\n        ")], 1), _vm._v(" "), _c('span', {
    staticClass: "col-xs-12 col-md-6 tab-link",
    on: {
      "click": function($event) {
        _vm.switchLang('us')
      }
    }
  }, [_c('country-flag', {
    attrs: {
      "country": "us",
      "size": "small"
    }
  }), _vm._v(" English\n        ")], 1), _vm._v(" "), _c('span', {
    staticClass: "col-xs-12 col-md-6 tab-link",
    on: {
      "click": function($event) {
        _vm.switchLang('de')
      }
    }
  }, [_c('country-flag', {
    attrs: {
      "country": "de",
      "size": "small"
    }
  }), _vm._v(" Deutsche\n        ")], 1), _vm._v(" "), _c('span', {
    staticClass: "col-xs-12 col-md-6 tab-link",
    on: {
      "click": function($event) {
        _vm.switchLang('br')
      }
    }
  }, [_c('country-flag', {
    attrs: {
      "country": "br",
      "size": "small"
    }
  }), _vm._v(" Português\n        ")], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notFound"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/system128.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [(_vm.flag === 'es') ? _c('h1', [_vm._v("¿Usted está perdido?")]) : (_vm.flag === 'de') ? _c('h1', [_vm._v("Bist du verloren?")]) : (_vm.flag === 'us') ? _c('h1', [_vm._v("You are lost?")]) : _c('h1', [_vm._v("Você está perdido?")]), _vm._v(" "), (_vm.flag === 'es') ? _c('h4', [_vm._v("¡Esta página no existe!")]) : (_vm.flag === 'de') ? _c('h4', [_vm._v("Diese Seite existiert nicht!")]) : (_vm.flag === 'us') ? _c('h4', [_vm._v("This page does not exist!")]) : _c('h4', [_vm._v("Essa página não existe!")]), _vm._v(" "), _c('router-link', {
    staticClass: "vertical-5p lead",
    attrs: {
      "to": "/"
    }
  }, [(_vm.flag === 'es') ? _c('span', [_vm._v("Ve a la principal.")]) : (_vm.flag === 'de') ? _c('span', [_vm._v("Gehe zum Haupt.")]) : (_vm.flag === 'us') ? _c('span', [_vm._v("Ve a la principal.")]) : _c('span', [_vm._v("Ir para a principal.")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "notification-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('h4', [(_vm.flag === 'es') ? _c('span', [_vm._v(_vm._s(_vm.notification.labelEs))]) : (_vm.flag === 'de') ? _c('span', [_vm._v(_vm._s(_vm.notification.labelDe))]) : (_vm.flag === 'us') ? _c('span', [_vm._v(_vm._s(_vm.notification.labelEn))]) : _c('span', [_vm._v(_vm._s(_vm.notification.labelPtBr))]), _vm._v(" "), _c('small', {
    staticClass: "time pull-right"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.notification.data_atualizacao))])])])])])
},staticRenderFns: []}

/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('languages-menu'), _vm._v(" "), _c('notifications-menu'), _vm._v(" "), _c('user-menu', {
    attrs: {
      "user": _vm.user
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "logo-mini"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive center-block logo",
    attrs: {
      "src": "/static/img/bi-logo-archea-biogas2.svg",
      "alt": "Logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
}]}

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "user-panel"
  }, [_c('div', {
    staticClass: "pull-left image"
  }, [_c('img', {
    attrs: {
      "src": _vm.pictureUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-left info"
  }, [_c('div', [_c('p', {
    staticClass: "white"
  }, [_vm._v(_vm._s(_vm.displayName))])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('form', {
    staticClass: "sidebar-form",
    attrs: {
      "id": "searchForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('sidebar-menu')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle text-success"
  }), _vm._v(" Online\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group",
    attrs: {
      "id": "searchContainer"
    }
  }, [_c('span', {
    staticClass: "input-group-btn"
  }, [_c('input', {
    staticClass: "search form-control",
    attrs: {
      "type": "text",
      "name": "search",
      "id": "search",
      "data-toggle": "hideseek",
      "p": "",
      "laceholder": "Search Menus",
      "data-list": ".sidebar-menu"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-flat",
    attrs: {
      "type": "submit",
      "name": "search",
      "id": "search-btn"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])
}]}

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    attrs: {
      "id": "row center-block"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "displayName"
    }
  }, [(_vm.flag === 'es') ? _c('span', [_vm._v("Nombre de usuario")]) : (_vm.flag === 'de') ? _c('span', [_vm._v("Benutzername")]) : (_vm.flag === 'us') ? _c('span', [_vm._v("Username")]) : _c('span', [_vm._v("Nome do Usuário")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayNameNew),
      expression: "displayNameNew"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "displayName"
    },
    domProps: {
      "value": (_vm.displayNameNew)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.displayNameNew = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "buttom"
    },
    on: {
      "click": function($event) {
        _vm.alterarNomeUsuario()
      }
    }
  }, [(_vm.flag === 'es') ? _c('span', [_vm._v("Registro")]) : (_vm.flag === 'de') ? _c('span', [_vm._v("Aufnehmen")]) : (_vm.flag === 'us') ? _c('span', [_vm._v("Save")]) : _c('span', [_vm._v("Gravar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "buttom"
    },
    on: {
      "click": function($event) {
        _vm.alterarSenhaUsuario()
      }
    }
  }, [(_vm.flag === 'es') ? _c('span', [_vm._v("Restablecer contraseña")]) : (_vm.flag === 'de') ? _c('span', [_vm._v("Passwort zurücksetzen")]) : (_vm.flag === 'us') ? _c('span', [_vm._v("Redefine password")]) : _c('span', [_vm._v("Redefinir Senha")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-sm-block"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},staticRenderFns: []}

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [(_vm.flag === 'es') ? _c('li', {
    staticClass: "header"
  }, [_vm._v("Páginas")]) : (_vm.flag === 'de') ? _c('li', {
    staticClass: "header"
  }, [_vm._v("Seiten")]) : (_vm.flag === 'us') ? _c('li', {
    staticClass: "header"
  }, [_vm._v("Pages")]) : _c('li', {
    staticClass: "header"
  }, [_vm._v("Páginas")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), (_vm.flag === 'es') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Principal")]) : (_vm.flag === 'de') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Main")]) : (_vm.flag === 'us') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Home")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Principal")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/manutencao"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa ion-android-settings"
  }), _vm._v(" "), (_vm.flag === 'es') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Mantenimiento")]) : (_vm.flag === 'de') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Wartung")]) : (_vm.flag === 'us') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Maintenance")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Manutenção")])])]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa ion-stats-bars"
  }), _vm._v(" "), (_vm.flag === 'es') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Gráficos")]) : (_vm.flag === 'de') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Diagramme")]) : (_vm.flag === 'us') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Charts")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Gráficos")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/graficos"
    }
  }, [_c('a', [(_vm.flag === 'es') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("General")]) : (_vm.flag === 'de') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Allgemein")]) : (_vm.flag === 'us') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("General")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Gerais")])])])], 1)])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/graficos-material"
    }
  }, [_c('a', [(_vm.flag === 'es') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Material")]) : (_vm.flag === 'de') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Material")]) : (_vm.flag === 'us') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Material")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Material")])])])], 1)])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('a', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/graficos-acumulados"
    }
  }, [_c('a', [(_vm.flag === 'es') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Acumulado por día")]) : (_vm.flag === 'de') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Pro Tag akkumuliert")]) : (_vm.flag === 'us') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Accumulated per day")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Acumulados por dia")])])])], 1)])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/usuario"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), (_vm.flag === 'es') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Usuario")]) : (_vm.flag === 'de') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Benutzer")]) : (_vm.flag === 'us') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("User")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Usuário")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/logout"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" "), (_vm.flag === 'es') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Cerrar Sesión")]) : (_vm.flag === 'de') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Ausloggen")]) : (_vm.flag === 'us') ? _c('span', {
    staticClass: "page"
  }, [_vm._v("Logout")]) : _c('span', {
    staticClass: "page"
  }, [_vm._v("Sair")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])
}]}

/***/ }),
/* 340 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": _vm.user.avatar,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.user.displayName))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header",
    staticStyle: {
      "height": "auto",
      "min-height": "85px",
      "padding-bottom": "15px"
    }
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.user.displayName))]), _vm._v(" "), _vm._l((_vm.user.roles), function(role) {
    return _c('small', {
      key: role
    }, [_vm._v(_vm._s(role))])
  })], 2)]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/logout"
    }
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat btn-block"
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Logout")])])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown tasks-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.userInfo.tasks)) + " ")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.userInfo.tasks)) + " task(s)")]), _vm._v(" "), (_vm.userInfo.tasks.length > 0) ? _c('li', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.userInfo.tasks.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("View all tasks")])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('h3', [_vm._v("\n              Design some buttons\n              "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("20%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-aqua",
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "20",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("20% Complete")])])])])])])
}]}

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [(_vm.exibirGrafico) ? _c('div', {
    staticClass: "box-header"
  }, [_c('va-chart', {
    attrs: {
      "chart-config": _vm.producaoGrafico
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [(_vm.flag === 'br') ? _c('h3', [_vm._v("Requisitos de pesquisa")]) : (_vm.flag === 'de') ? _c('h3', [_vm._v("Suchanforderungen")]) : (_vm.flag === 'us') ? _c('h3', [_vm._v("Search Requirements")]) : _c('h3', [_vm._v("Requerimientos de búsqueda")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.flag === 'br') ? _c('h4', [_vm._v("Período")]) : (_vm.flag === 'de') ? _c('h4', [_vm._v("Zeitraum")]) : (_vm.flag === 'us') ? _c('h4', [_vm._v("Period")]) : _c('h4', [_vm._v("Periodo")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [(_vm.flag === 'br') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Data Inicial")]) : (_vm.flag === 'de') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Startdatum")]) : (_vm.flag === 'us') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Initial date")]) : _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Fecha de inicio")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.flag === 'br') ? _c('datepicker', {
    attrs: {
      "placeholder": "Selecione a data inicial",
      "id": "dataInicioBusca",
      "language": _vm.ptBR
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  }) : (_vm.flag === 'de') ? _c('datepicker', {
    attrs: {
      "placeholder": "Startdatum auswählen",
      "id": "dataInicioBusca",
      "language": _vm.de
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  }) : (_vm.flag === 'us') ? _c('datepicker', {
    attrs: {
      "placeholder": "Select start date",
      "id": "dataInicioBusca",
      "language": _vm.en
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  }) : _c('datepicker', {
    attrs: {
      "placeholder": "Seleccionar fecha de inicio",
      "id": "dataInicioBusca",
      "language": _vm.es
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), (_vm.flag === 'br') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Data Final")]) : (_vm.flag === 'de') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Enddatum")]) : (_vm.flag === 'us') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Final date")]) : _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Fecha final")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.flag === 'br') ? _c('datepicker', {
    attrs: {
      "placeholder": "Selecione a data final",
      "id": "dataFimBusca",
      "language": _vm.ptBR
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  }) : (_vm.flag === 'de') ? _c('datepicker', {
    attrs: {
      "placeholder": "Wählen Sie das Enddatum",
      "id": "dataFimBusca",
      "language": _vm.de
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  }) : (_vm.flag === 'us') ? _c('datepicker', {
    attrs: {
      "placeholder": "Select end date",
      "id": "dataFimBusca",
      "language": _vm.en
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  }) : _c('datepicker', {
    attrs: {
      "placeholder": "Seleccionar fecha de finalización",
      "id": "dataFimBusca",
      "language": _vm.es
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "input-group"
  }, [(_vm.flag === 'br') ? _c('h4', [_vm._v("Parâmetro")]) : (_vm.flag === 'de') ? _c('h4', [_vm._v("Parameter")]) : (_vm.flag === 'us') ? _c('h4', [_vm._v("Parameter")]) : _c('h4', [_vm._v("Parámetro")]), _vm._v(" "), (_vm.flag === 'br') ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione o parâmetro")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.registros, true, 'is_acumulador'), 'labelPtBr')), function(registro, propriedade, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": registro
      }
    }, [_vm._v(_vm._s(registro.$value.labelPtBr))])
  })], 2)]) : (_vm.flag === 'de') ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Parameter auswählen")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.registros, true, 'is_acumulador'), 'labelDe')), function(registro, propriedade, index) {
    return _c('option', {
      key: _vm.key,
      domProps: {
        "value": registro
      }
    }, [_vm._v(_vm._s(registro.$value.labelDe))])
  })], 2)]) : (_vm.flag === 'us') ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Parameter")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.registros, true, 'is_acumulador'), 'labelEn')), function(registro, propriedade, index) {
    return _c('option', {
      key: _vm.key,
      domProps: {
        "value": registro
      }
    }, [_vm._v(_vm._s(registro.$value.labelEn))])
  })], 2)]) : _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccionar parámetro")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.registros, true, 'is_acumulador'), 'labelEs')), function(registro, propriedade, index) {
    return _c('option', {
      key: _vm.key,
      domProps: {
        "value": registro
      }
    }, [_vm._v(_vm._s(registro.$value.labelEs))])
  })], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-2",
    attrs: {
      "v": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.efetuarPesquisa(_vm.flag)
      }
    }
  }, [(_vm.flag === 'br') ? _c('span', [_vm._v("Efetuar Pesquisa")]) : (_vm.flag === 'de') ? _c('span', [_vm._v("Suche")]) : (_vm.flag === 'us') ? _c('span', [_vm._v("Search")]) : _c('span', [_vm._v("Buscar")])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.userInfo.messages)))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.userInfo.messages)) + " message(s)")]), _vm._v(" "), (_vm.userInfo.messages.length > 0) ? _c('li', [_c('ul', {
    staticClass: "menu"
  }, _vm._l((_vm.userInfo.messages), function(message) {
    return _c('message-item', {
      key: message.id,
      attrs: {
        "message": message
      }
    })
  }))]) : _vm._e(), _vm._v(" "), (_vm.userInfo.messages.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("See All Messages")])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [(_vm.exibirGrafico) ? _c('div', {
    staticClass: "box-header"
  }, [_c('va-chart', {
    attrs: {
      "chart-config": _vm.producaoGrafico
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [(_vm.flag === 'br') ? _c('h3', [_vm._v("Requisitos de pesquisa")]) : (_vm.flag === 'de') ? _c('h3', [_vm._v("Suchanforderungen")]) : (_vm.flag === 'us') ? _c('h3', [_vm._v("Search Requirements")]) : _c('h3', [_vm._v("Requerimientos de búsqueda")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.flag === 'br') ? _c('h4', [_vm._v("Período")]) : (_vm.flag === 'de') ? _c('h4', [_vm._v("Zeitraum")]) : (_vm.flag === 'us') ? _c('h4', [_vm._v("Period")]) : _c('h4', [_vm._v("Periodo")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [(_vm.flag === 'br') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Data Inicial")]) : (_vm.flag === 'de') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Startdatum")]) : (_vm.flag === 'us') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Initial date")]) : _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Fecha de inicio")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.flag === 'br') ? _c('datepicker', {
    attrs: {
      "placeholder": "Selecione a data inicial",
      "id": "dataInicioBusca",
      "language": _vm.ptBR
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  }) : (_vm.flag === 'de') ? _c('datepicker', {
    attrs: {
      "placeholder": "Startdatum auswählen",
      "id": "dataInicioBusca",
      "language": _vm.de
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  }) : (_vm.flag === 'us') ? _c('datepicker', {
    attrs: {
      "placeholder": "Select start date",
      "id": "dataInicioBusca",
      "language": _vm.en
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  }) : _c('datepicker', {
    attrs: {
      "placeholder": "Seleccionar fecha de inicio",
      "id": "dataInicioBusca",
      "language": _vm.es
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), (_vm.flag === 'br') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Data Final")]) : (_vm.flag === 'de') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Enddatum")]) : (_vm.flag === 'us') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Final date")]) : _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Fecha final")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.flag === 'br') ? _c('datepicker', {
    attrs: {
      "placeholder": "Selecione a data final",
      "id": "dataFimBusca",
      "language": _vm.ptBR
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  }) : (_vm.flag === 'de') ? _c('datepicker', {
    attrs: {
      "placeholder": "Wählen Sie das Enddatum",
      "id": "dataFimBusca",
      "language": _vm.de
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  }) : (_vm.flag === 'us') ? _c('datepicker', {
    attrs: {
      "placeholder": "Select end date",
      "id": "dataFimBusca",
      "language": _vm.en
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  }) : _c('datepicker', {
    attrs: {
      "placeholder": "Seleccionar fecha de finalización",
      "id": "dataFimBusca",
      "language": _vm.es
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "input-group"
  }, [(_vm.flag === 'br') ? _c('h4', [_vm._v("Parâmetro")]) : (_vm.flag === 'de') ? _c('h4', [_vm._v("Parameter")]) : (_vm.flag === 'us') ? _c('h4', [_vm._v("Parameter")]) : _c('h4', [_vm._v("Parámetro")]), _vm._v(" "), (_vm.flag === 'br') ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione o parâmetro")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, false, 'is_acumulador'), true, 'registrado'), 'labelPtBr')), function(registro, propriedade, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": registro
      }
    }, [_vm._v(_vm._s(registro.$value.labelPtBr))])
  })], 2)]) : (_vm.flag === 'de') ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Parameter auswählen")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, false, 'is_acumulador'), true, 'registrado'), 'labelDe')), function(registro, propriedade, index) {
    return _c('option', {
      key: _vm.key,
      domProps: {
        "value": registro
      }
    }, [_vm._v(_vm._s(registro.$value.labelDe))])
  })], 2)]) : (_vm.flag === 'us') ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Parameter")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, false, 'is_acumulador'), true, 'registrado'), 'labelEn')), function(registro, propriedade, index) {
    return _c('option', {
      key: _vm.key,
      domProps: {
        "value": registro
      }
    }, [_vm._v(_vm._s(registro.$value.labelEn))])
  })], 2)]) : _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccionar parámetro")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, false, 'is_acumulador'), true, 'registrado'), 'labelEs')), function(registro, propriedade, index) {
    return _c('option', {
      key: _vm.key,
      domProps: {
        "value": registro
      }
    }, [_vm._v(_vm._s(registro.$value.labelEs))])
  })], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-2",
    attrs: {
      "v": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.efetuarPesquisa(_vm.flag)
      }
    }
  }, [(_vm.flag === 'br') ? _c('span', [_vm._v("Efetuar Pesquisa")]) : (_vm.flag === 'de') ? _c('span', [_vm._v("Suche")]) : (_vm.flag === 'us') ? _c('span', [_vm._v("Search")]) : _c('span', [_vm._v("Buscar")])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/system128.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.signIn($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "placeholder": "Digite seu email",
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "placeholder": "Digite sua senha",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Entrar")])]), _vm._v(" "), (_vm.response) ? _c('div', {
    staticClass: "text-red"
  }, [_c('p', {
    staticClass: "vertical-5p lead"
  }, [_vm._v(_vm._s(_vm.response))])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}

/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('dash-header', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "display-name": _vm.demo.displayName,
      "picture-url": _vm.demo.avatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [(_vm.flag === 'es') ? _c('span', [_vm._v(_vm._s(_vm.$route.meta.nameEs.toUpperCase()))]) : (_vm.flag === 'de') ? _c('span', [_vm._v(_vm._s(_vm.$route.meta.nameDe.toUpperCase()))]) : (_vm.flag === 'us') ? _c('span', [_vm._v(_vm._s(_vm.$route.meta.nameEn.toUpperCase()))]) : _c('span', [_vm._v(_vm._s(_vm.$route.meta.namePtbr.toUpperCase()))]), _vm._v(" "), (_vm.flag === 'es') ? _c('small', [_vm._v(_vm._s(_vm.$route.meta.descriptionEs))]) : (_vm.flag === 'de') ? _c('small', [_vm._v(_vm._s(_vm.$route.meta.descriptionDe))]) : (_vm.flag === 'us') ? _c('small', [_vm._v(_vm._s(_vm.$route.meta.descriptionEn))]) : _c('small', [_vm._v(_vm._s(_vm.$route.meta.descriptionPtbr))])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), (_vm.flag === 'es') ? _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.meta.nameEs.toUpperCase()) + "\n        ")]) : (_vm.flag === 'de') ? _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.meta.nameDe.toUpperCase()))]) : (_vm.flag === 'us') ? _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.meta.nameEn.toUpperCase()))]) : _c('li', {
    staticClass: "active"
  }), _vm._v(_vm._s(_vm.$route.meta.namePtbr.toUpperCase()))])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('dash-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Granja Ronchi")])])
}]}

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [(_vm.exibirGrafico) ? _c('div', {
    staticClass: "box-header"
  }, [_c('va-chart', {
    attrs: {
      "chart-config": _vm.producaoGrafico
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [(_vm.flag === 'br') ? _c('h3', [_vm._v("Requisitos de pesquisa")]) : (_vm.flag === 'de') ? _c('h3', [_vm._v("Suchanforderungen")]) : (_vm.flag === 'us') ? _c('h3', [_vm._v("Search Requirements")]) : _c('h3', [_vm._v("Requerimientos de búsqueda")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.flag === 'br') ? _c('h4', [_vm._v("Período")]) : (_vm.flag === 'de') ? _c('h4', [_vm._v("Zeitraum")]) : (_vm.flag === 'us') ? _c('h4', [_vm._v("Period")]) : _c('h4', [_vm._v("Periodo")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [(_vm.flag === 'br') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Data Inicial")]) : (_vm.flag === 'de') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Startdatum")]) : (_vm.flag === 'us') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Initial date")]) : _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Fecha de inicio")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.flag === 'br') ? _c('datepicker', {
    attrs: {
      "placeholder": "Selecione a data inicial",
      "id": "dataInicioBusca",
      "language": _vm.ptBR
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  }) : (_vm.flag === 'de') ? _c('datepicker', {
    attrs: {
      "placeholder": "Startdatum auswählen",
      "id": "dataInicioBusca",
      "language": _vm.de
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  }) : (_vm.flag === 'us') ? _c('datepicker', {
    attrs: {
      "placeholder": "Select start date",
      "id": "dataInicioBusca",
      "language": _vm.en
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  }) : _c('datepicker', {
    attrs: {
      "placeholder": "Seleccionar fecha de inicio",
      "id": "dataInicioBusca",
      "language": _vm.es
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), (_vm.flag === 'br') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Data Final")]) : (_vm.flag === 'de') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Enddatum")]) : (_vm.flag === 'us') ? _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Final date")]) : _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Fecha final")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.flag === 'br') ? _c('datepicker', {
    attrs: {
      "placeholder": "Selecione a data final",
      "id": "dataFimBusca",
      "language": _vm.ptBR
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  }) : (_vm.flag === 'de') ? _c('datepicker', {
    attrs: {
      "placeholder": "Wählen Sie das Enddatum",
      "id": "dataFimBusca",
      "language": _vm.de
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  }) : (_vm.flag === 'us') ? _c('datepicker', {
    attrs: {
      "placeholder": "Select end date",
      "id": "dataFimBusca",
      "language": _vm.en
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  }) : _c('datepicker', {
    attrs: {
      "placeholder": "Seleccionar fecha de finalización",
      "id": "dataFimBusca",
      "language": _vm.es
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "input-group"
  }, [(_vm.flag === 'br') ? _c('h4', [_vm._v("Parâmetro")]) : (_vm.flag === 'de') ? _c('h4', [_vm._v("Parameter")]) : (_vm.flag === 'us') ? _c('h4', [_vm._v("Parameter")]) : _c('h4', [_vm._v("Parámetro")]), _vm._v(" "), (_vm.flag === 'br') ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione o parâmetro")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'exibir'), true, 'is_qualidade'), 'labelPtBr')), function(registro, propriedade, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": registro
      }
    }, [_vm._v(_vm._s(registro.$value.labelPtBr))])
  })], 2)]) : (_vm.flag === 'de') ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Parameter auswählen")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'exibir'), true, 'is_qualidade'), 'labelDe')), function(registro, propriedade, index) {
    return _c('option', {
      key: _vm.key,
      domProps: {
        "value": registro
      }
    }, [_vm._v(_vm._s(registro.$value.labelDe))])
  })], 2)]) : (_vm.flag === 'us') ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Parameter")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'exibir'), true, 'is_qualidade'), 'labelEn')), function(registro, propriedade, index) {
    return _c('option', {
      key: _vm.key,
      domProps: {
        "value": registro
      }
    }, [_vm._v(_vm._s(registro.$value.labelEn))])
  })], 2)]) : _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parametro),
      expression: "parametro"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "parametro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parametro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccionar parámetro")]), _vm._v(" "), _vm._l((_vm.orderBy(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'exibir'), true, 'is_qualidade'), 'labelEs')), function(registro, propriedade, index) {
    return _c('option', {
      key: _vm.key,
      domProps: {
        "value": registro
      }
    }, [_vm._v(_vm._s(registro.$value.labelEs))])
  })], 2)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-2",
    attrs: {
      "v": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.efetuarPesquisa(_vm.flag)
      }
    }
  }, [(_vm.flag === 'br') ? _c('span', [_vm._v("Efetuar Pesquisa")]) : (_vm.flag === 'de') ? _c('span', [_vm._v("Suche")]) : (_vm.flag === 'us') ? _c('span', [_vm._v("Search")]) : _c('span', [_vm._v("Buscar")])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 349 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown notifications-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_alarme'), 1, 'valor'))))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "row no-margin"
  }, _vm._l((_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_alarme'), 1, 'valor')), function(registro) {
    return _c('span', {
      staticClass: "col-xs-12 col-md-6 tab-link"
    }, [(_vm.flag === 'es') ? _c('i', {
      staticClass: "fa fa-warning"
    }, [_vm._v(" " + _vm._s(registro.labelEs))]) : (_vm.flag === 'de') ? _c('i', {
      staticClass: "fa fa-warning"
    }, [_vm._v(" " + _vm._s(registro.labelDe))]) : (_vm.flag === 'us') ? _c('i', {
      staticClass: "fa fa-warning"
    }, [_vm._v(" " + _vm._s(registro.labelEn))]) : _c('i', {
      staticClass: "fa fa-warning"
    }, [_vm._v(" " + _vm._s(registro.labelPtBr))])])
  }))]), _vm._v(" "), _c('li', [(_vm.tab === 'old') ? _c('ul', {
    staticClass: "menu"
  }, [_vm._l((_vm.filterBy(_vm.filterBy(_vm.registros, true, 'is_alarme'), 1, 'valor')), function(notification) {
    return _c('notification-item', {
      key: notification.id,
      attrs: {
        "notification": notification
      }
    })
  }), _vm._v(" "), (!_vm.oldNotifications.length) ? _c('li', [_c('span', {
    staticClass: "center-block text-center"
  }, [_vm._v("Não existe nenhum alerta/alarme")])]) : _vm._e()], 2) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas')
},staticRenderFns: []}

/***/ }),
/* 351 */,
/* 352 */,
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Relatorios.js": 197,
	"./index.js": 28
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 353;

/***/ }),
/* 354 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[195]);


// WEBPACK FOOTER //
// static/js/app.e47a920e4d293cd1b08e.js